export default "__VITE_ASSET__adi6eBSV__"